
/**
 * 签单管理 - 签单表
 */
<template>
  <div class="customer-sign-order-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">签单管理</el-breadcrumb-item>
      <el-breadcrumb-item>签单表</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="search-section">
      <el-form :inline="true" :model="formInline" size="small" class="search-form">
        <el-form-item label="商户">
          <el-input
            v-model="formInline.merchantName"
            placeholder="请输入商户名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="formInline.providerName"
            placeholder="请输入服务商名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="电销">
          <el-input
            v-model="formInline.phoneSaleName"
            placeholder="请输入电销名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="面销">
          <el-input
            v-model="formInline.faceSaleName"
            placeholder="请输入面销名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="转交电销">
          <el-input
            v-model="formInline.transferPhoneSalesName"
            placeholder="请输入转交电销名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="转交面销">
          <el-input
            v-model="formInline.transferFaceSalesName"
            placeholder="请输入转交面销名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-input
            v-model="formInline.ownerName"
            placeholder="请输入渠道名称"
            clearable
            class="search-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属地">
          <el-select
            v-model="formInline.location"
            placeholder="请选择所属地"
            clearable
            class="search-input"
          >
            <el-option label="北京" value="北京"></el-option>
            <el-option label="石家庄" value="石家庄"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约时间">
          <el-date-picker
            v-model="signOrderDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            class="search-date-picker"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="返点">
          <el-select
            v-model="formInline.hasRebate"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务商状态">
          <el-select
            v-model="formInline.providerEnableStatus"
            placeholder="全部"
            clearable
            class="search-input"
          >
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="停用时间">
          <el-date-picker
            v-model="providerDisabledDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            clearable
            class="search-date-picker"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <div class="left-actions">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="onOpenAddDialog()">新增</el-button>
        <el-button size="small" icon="el-icon-download" @click="exprotData()" :loading="exportButtonLoading">导出</el-button>
        <el-button size="small" icon="el-icon-link" @click="onOpenMatchDialog()">匹配</el-button>
        <el-button size="small" icon="el-icon-document" @click="onMatchLog()">匹配记录</el-button>
      </div>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
        border
      >
      <el-table-column
        fixed
        prop="merchantName"
        label="商户"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.merchantName)">
            {{ scope.row.merchantName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="providerName" label="服务商" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.providerName)">
            {{ scope.row.providerName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="quotePrice" label="合同报价" show-overflow-tooltip>
        <template #default="scope">
          {{ formatPercent(scope.row.quotePrice) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="modifiedPrice"
        label="合同改价"
        show-overflow-tooltip
      >
        <template #default="scope">
          <div class="price-cell" @click="showPriceHistory(scope.row, 1)">
            <span class="price-value">{{
              formatPercent(scope.row.modifiedPrice)
            }}</span>
            <i
              v-if="scope.row.lastModifiedPriceDate"
              class="el-icon-view history-icon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="lastModifiedPriceDate"
        label="合同改价日期"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>

      <el-table-column
        prop="actualQuotePrice"
        label="实际报价"
        show-overflow-tooltip
      >
        <template #default="scope">
          {{ formatPercent(scope.row.actualQuotePrice) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="actualQuoteModifiedPrice"
        label="实际改价"
        show-overflow-tooltip
      >
        <template #default="scope">
          <div class="price-cell" @click="showPriceHistory(scope.row, 2)">
            <span class="price-value">{{
              formatPercent(scope.row.actualQuoteModifiedPrice)
            }}</span>
            <i
              v-if="scope.row.actualQuoteModifiedPriceDate"
              class="el-icon-view history-icon"
            ></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="actualQuoteModifiedPriceDate"
        label="实际改价日期"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column prop="rebate" label="返点" show-overflow-tooltip>
        <template #default="scope">
          {{ formatPercent(scope.row.rebate) }}
        </template>
      </el-table-column>
      <el-table-column prop="businessType" label="业务" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invoiceContent"
        label="发票内容"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.invoiceContent)">
            {{ scope.row.invoiceContent }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="isCreateGroup" label="建群" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.isCreateGroup === 1 ? 'success' : 'danger'"
            size="small"
          >
            {{ scope.row.isCreateGroup === 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="specialIndustry" label="特殊行业" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.specialIndustry === 1 ? 'success' : 'danger'"
            size="small"
          >
            {{ scope.row.specialIndustry === 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="signDate" label="签约日期" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="startDate" label="启动时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="providerEnableStatus"
        label="服务商启用状态"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <template
            v-if="
              scope.row.providerEnableStatus === 1 ||
              scope.row.providerEnableStatus === '1'
            "
          >
            <el-tag type="success" size="small">启用</el-tag>
          </template>
          <template
            v-else-if="
              scope.row.providerEnableStatus === 0 ||
              scope.row.providerEnableStatus === '0'
            "
          >
            <el-tag type="info" size="small">停用</el-tag>
          </template>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="providerDisabledDate"
        label="停用时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="accountStatus" label="开户" show-overflow-tooltip>
        <template slot-scope="scope">
          <i
            :class="[
              scope.row.accountStatus === 1 ? 'el-icon-check' : 'el-icon-close',
              'table-status-icon',
            ]"
            :style="{
              color: scope.row.accountStatus === 1 ? '#67c23a' : '#f56c6c',
            }"
          ></i>
        </template>
      </el-table-column>
      <el-table-column
        prop="archiveDate"
        label="归档日期"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="phoneSales" label="电销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="faceSales" label="面销" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="transferPhoneSalesName" label="转交电销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferPhoneSalesName }}
        </template>
      </el-table-column>
      <el-table-column prop="transferFaceSalesName" label="转交面销" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.transferFaceSalesName }}
        </template>
      </el-table-column>
      <el-table-column prop="owner" label="渠道" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column fixed="right" align="left" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="handleModify(scope.row)"
            >修改</el-button
          >
          <el-button
            size="small"
            type="danger"
            @click="handlesDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
      <div class="pagination-wrap">
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </div>
    </el-card>
    <!-- 编辑界面 -->
    <el-dialog
      :title="addDialog.title"
      :visible.sync="addDialog.visible"
      :close-on-click-modal="false"
      custom-class="sign-dialog"
      top="6vh"
      width="900px"
    >
      <el-form
        ref="formRef"
        :model="editForm"
        :rules="rules"
        label-width="110px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商户：" prop="merchantId">
              <el-select
                v-model="editForm.merchantId"
                filterable
                remote
                reserve-keyword
                placeholder="请输入商户关键词"
                :remote-method="getMerchantName"
                :loading="getMerchantNameLoading"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in merchantList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务商：" prop="providerIds">
              <el-select
                v-model="editForm.providerIds"
                filterable
                remote
                multiple
                collapse-tags
                reserve-keyword
                placeholder="请输入服务商关键词"
                :remote-method="getProviderName"
                :loading="getProviderNameLoading"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="item in providerList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同报价：" prop="quotePrice">
              <el-input
                v-model="editForm.quotePrice"
                placeholder="请输入报价"
                type="number"
                min="0"
                step="0.01"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际报价：" prop="actualQuotePrice">
              <el-input
                v-model="editForm.actualQuotePrice"
                placeholder="请输入实际报价"
                type="number"
                min="0"
                step="0.01"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同改价：" prop="modifiedPrice">
              <el-input
                v-model="editForm.modifiedPrice"
                placeholder="请输入合同改价"
                type="number"
                min="0"
                step="0.01"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="实际改价：" prop="actualQuoteModifiedPrice">
              <el-input
                v-model="editForm.actualQuoteModifiedPrice"
                placeholder="请输入实际改价"
                type="number"
                min="0"
                step="0.01"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同改价日期：" prop="lastModifiedPriceDate">
              <el-date-picker
                v-model="editForm.lastModifiedPriceDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="实际改价日期："
              prop="actualQuoteModifiedPriceDate"
            >
              <el-date-picker
                v-model="editForm.actualQuoteModifiedPriceDate"
                type="date"
                placeholder="选择实际改价日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="返点：" prop="rebate">
              <el-input
                v-model="editForm.rebate"
                placeholder="请输入返点"
                type="number"
                min="0"
                step="0.01"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务类型：" prop="businessType">
              <el-select
                v-model="editForm.businessType"
                placeholder="请选择业务类型"
                style="width: 100%"
              >
                <el-option label="差额普" value="差额普"></el-option>
                <el-option label="灵活用工" value="灵活用工"></el-option>
                <el-option label="其它" value="其它"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票内容：" prop="invoiceContent">
              <el-input
                v-model="editForm.invoiceContent"
                placeholder="请输入发票内容"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="归档日期：" prop="archiveDate">
              <el-date-picker
                v-model="editForm.archiveDate"
                type="date"
                placeholder="选择归档日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="签约日期：" prop="signDate">
              <el-date-picker
                v-model="editForm.signDate"
                type="date"
                placeholder="选择签约日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启动时间：" prop="startDate">
              <el-date-picker
                v-model="editForm.startDate"
                type="date"
                placeholder="选择启动时间"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开户状态：" prop="accountStatus">
              <el-radio-group v-model="editForm.accountStatus">
                <el-radio :label="1">已开户</el-radio>
                <el-radio :label="0">未开户</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="建群：" prop="isCreateGroup">
              <el-radio-group v-model="editForm.isCreateGroup">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="特殊行业：" prop="specialIndustry">
              <el-radio-group v-model="editForm.specialIndustry">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAddDialog()">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleSubmit"
          :loading="submitLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="priceHistoryDialog.title"
      :visible.sync="priceHistoryDialog.visible"
      width="700px"
      :close-on-click-modal="false"
      custom-class="price-history-dialog"
    >
      <div class="price-history-container">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in priceHistoryList"
            :key="index"
            :timestamp="item.modifiedPriceDate"
            placement="top"
            :color="getTimelineColor(item.decreaseOrIncrease)"
          >
            <el-card shadow="hover" class="history-card">
              <div class="history-content">
                <div class="price-change">
                  <span class="old-price">{{
                    formatPercent(item.oldPrice)
                  }}</span>
                  <i class="el-icon-right change-icon"></i>
                  <span class="new-price">{{
                    formatPercent(item.newPrice)
                  }}</span>
                  <el-tag
                    size="mini"
                    :type="getChangeTypeTag(item.decreaseOrIncrease)"
                    class="change-type-tag"
                  >
                    {{ getChangeTypeText(item.decreaseOrIncrease) }}
                  </el-tag>
                </div>

                <div class="detail-item">
                  <span class="label">备注：</span>
                  <span class="value">{{ item.remark }}</span>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>

        <!-- 空状态 -->
        <div v-if="priceHistoryList.length === 0" class="empty-state">
          <i class="el-icon-tickets empty-icon"></i>
          <p class="empty-text">暂无改价历史记录</p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="priceHistoryDialog.visible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="matchDialog.title"
      :visible.sync="matchDialog.visible"
      @open="matchDialogOpen"
      width="500px"
      custom-class="match-dialog"
      @click="closeMatchDialog"
    >
      <el-form
        label-width="120px"
        :model="matchForm"
        :rules="rules"
        ref="signForm"
      >
        <el-form-item label="匹配月份" prop="matchMonth">
          <el-date-picker
            v-model="matchForm.matchMonth"
            type="month"
            placeholder="选择月份"
            value-format="yyyy-MM"
            format="yyyy年MM月"
            size="small"
          >
          </el-date-picker>
        </el-form-item>
        <div
          style="
            display: flex;
            margin-left: 30px;
            margin-top: 20px;
            justify-content: flex-start;
            align-items: baseline;
          "
        >
          <el-button
            size="small"
            style="margin: 0 20px"
            @click="exampleDownload"
            >模板下载</el-button
          >
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :on-remove="handleMatchRemove"
            :on-change="fileOnChange"
            :file-list="matchFileList"
            :auto-upload="false"
          >
            <el-button size="small" slot="trigger" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeMatchDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="this.matchDialog.loading"
          class="title"
          @click="submitMatchTempForm()"
          >匹配</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerSignOrders,
  saveCustomerSignOrders,
  getCompanyNameList,
  updateCustomerSignOrders,
  deleteCustomerSignOrders,
  getChangePriceRecords,
  matchSettlementTemplate,
  matchSettlement,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { Message, MessageBox } from "element-ui";
export default {
  data() {
    return {
      matchForm: {
        matchMonth: "",
      },
      matchFileList: [],
      matchDialog: {
        title: "",
        visible: false,
        loading: false,
      },
      priceHistoryDialog: {
        visible: false,
        loading: false,
        title: "改价记录",
      },
      priceHistoryList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      submitLoading: false,
      merchantList: [],
      getMerchantNameLoading: false,
      providerList: [],
      getProviderNameLoading: false,
      exportButtonLoading: false,
      loading: false, //是显示加载
      addDialog: {
        title: "新增签单",
        visible: false,
        type: "",
      },

      editForm: {
        id: "",
        merchantId: "",
        providerId: "",
        providerIds: [],
        quotePrice: "",
        modifiedPrice: "",
        actualQuotePrice: "",
        rebate: "",
        lastModifiedPriceDate: "",
        actualQuoteModifiedPrice: "",
        actualQuoteModifiedPriceDate: "",
        businessType: "",
        invoiceContent: "",
        isCreateGroup: "",
        signDate: "",
        startDate: "",
        archiveDate: "",
        accountStatus: "",
        specialIndustry: "",
        remark: "",
      },
      // rules表单验证
      rules: {
        merchantId: [
          { required: true, message: "请选择商户", trigger: "blur" },
          { required: true, message: "请选择商户", trigger: "change" },
        ],
        providerIds: [
          {
            required: true,
            message: "请选择服务商",
            trigger: "change",
          },

          {
            required: true,
            message: "请选择服务商",
            trigger: "blur",
          },
        ],
        quotePrice: [
          { required: true, message: "请输入报价", trigger: "blur" },
          { pattern: /^\d+(\.\d{1,2})?$/, message: "请输入正确的报价格式" },
        ],
        modifiedPrice: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: "请输入正确的改价格式" },
        ],
        actualQuotePrice: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: "请输入正确的改价格式" },
        ],
        rebate: [
          { pattern: /^\d+(\.\d{1,2})?$/, message: "请输入正确的改价格式" },
        ],
        // lastModifiedPriceDate: [
        //   { pattern: /^\d{4}-\d{2}-\d{2}$/, message: "日期格式不正确" }
        // ],
        // businessType: [
        //   { required: true, message: "请选择业务类型", trigger: "change" }
        // ],
        // invoiceContent: [
        //   { max: 500, message: "发票内容不能超过500个字符", trigger: "blur" }
        // ],
        // signDate: [
        //   { required: true, message: "请选择签约日期", trigger: "change" },
        //   { pattern: /^\d{4}-\d{2}-\d{2}$/, message: "日期格式不正确" }
        // ],
        // startDate: [
        //   { pattern: /^\d{4}-\d{2}-\d{2}$/, message: "日期格式不正确" }
        // ],
        // archiveDate: [
        //   { pattern: /^\d{4}-\d{2}-\d{2}$/, message: "日期格式不正确" }
        // ],
        // remark: [
        //   { max: 1000, message: "备注不能超过1000个字符", trigger: "blur" }
        // ]
      },
      signOrderDate: [],
      /** 停用时间筛选 [start, end]，yyyy-MM-dd */
      providerDisabledDateRange: [],
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        providerName: "",
        startSignDate: "",
        endSignDate: "",
        phoneSaleName: "",
        faceSaleName: "",
        transferPhoneSalesName: "",
        transferFaceSalesName: "",
        ownerName: "",
        location: "",
        hasRebate: "",
        providerEnableStatus: "",
      },

      listData: [],
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },

  components: {
    Pagination,
  },
  mounted() {},

  created() {
    this.getdata(this.formInline);
  },

  methods: {
    showPriceHistory(row, type) {
      const params = {
        merchantId: row.merchantId,
        providerId: row.providerId,
        type: type, // 1: 合同改价历史, 2: 实际改价历史
      };
      // 根据类型设置弹窗标题
      this.priceHistoryDialog.title =
        type === 1 ? "合同改价记录" : "实际改价记录";
      this.priceHistoryDialog.visible = true;
      this.priceHistoryDialog.loading = true;

      getChangePriceRecords(params)
        .then((res) => {
          this.priceHistoryDialog.loading = false;
          if (res.msg === "success") {
            this.priceHistoryList = res.data || [];
            // 按时间倒序排列
          } else {
            this.$message.error(res.msg || "获取改价记录失败");
            this.priceHistoryList = [];
          }
        })
        .catch((err) => {
          this.priceHistoryDialog.loading = false;
          this.$message.error("获取改价记录失败");
        });
    },
    // 获取时间轴节点颜色
    getTimelineColor(changeType) {
      switch (changeType) {
        case 1: // 价格上涨
          return "#f56c6c";
        case 2: // 价格下降
          return "#67c23a";
        default: // 其他调整
          return "#409eff";
      }
    },

    // 获取改价类型标签样式
    getChangeTypeTag(changeType) {
      switch (changeType) {
        case 1: // 价格上涨
          return "danger";
        case 2: // 价格下降
          return "success";
        default: // 其他调整
          return "info";
      }
    },

    // 获取改价类型文字
    getChangeTypeText(changeType) {
      switch (changeType) {
        case 1:
          return "价格上调";
        case 2:
          return "价格下调";
        case 3:
          return "报价调整";
        default:
          return "价格调整";
      }
    },
    getMerchantName(query) {
      if (query !== "") {
        this.getMerchantNameLoading = true;
        const params = {
          page: 1,
          pageSize: 9999,
          type: 1,
          companyName: query,
        };
        getCompanyNameList(params)
          .then((res) => {
            this.getMerchantNameLoading = false;
            if (res.msg != "success") {
              this.$message({
                type: "error",
                message: res.msg,
              });
            } else {
              this.merchantList = res.data;
            }
          })
          .catch((err) => {
            this.getMerchantNameLoading = false;
          });
      } else {
        this.merchantList = [];
      }
    },
    getProviderName(query) {
      if (query !== "") {
        this.getProviderNameLoading = true;

        const params = {
          page: 1,
          pageSize: 9999,
          type: 2,
          companyName: query,
        };

        getCompanyNameList(params)
          .then((res) => {
            this.getProviderNameLoading = false;
            if (res.msg != "success") {
              this.$message({
                type: "error",
                message: res.msg,
              });
            } else {
              this.providerList = res.data;
            }
          })
          .catch((err) => {
            this.getProviderNameLoading = false;
          });
      } else {
        this.providerList = [];
      }
    },

    formatPercent(value) {
      if (value === null || value === undefined || value === 0) {
        return "";
      }

      try {
        if (typeof value === "string" && value.includes("%")) {
          return value;
        }

        const num = parseFloat(value);
        if (isNaN(num)) {
          return "";
        }

        // 乘以100，保留两位小数，加上百分号
        return (num * 100).toFixed(2) + "%";
      } catch (error) {
        return "";
      }
    },
    handleModify(row) {
      this.addDialog.title = "修改签单";
      this.addDialog.visible = true;
      this.addDialog.type = "edit";

      // 清空之前的商户和服务商列表
      this.merchantList = [];
      this.providerList = [];

      // 如果当前行有商户信息，添加到商户列表
      if (row.merchantId && row.merchantName) {
        this.merchantList = [
          {
            value: row.merchantId,
            label: row.merchantName,
          },
        ];
      }

      // 如果当前行有服务商信息，添加到服务商列表
      if (row.providerId && row.providerName) {
        this.providerList = [
          {
            value: row.providerId,
            label: row.providerName,
          },
        ];
      } else {
        this.providerList = []; // 无服务商时清空列表
      }

      // 填充表单数据，注意数据格式转换
      this.editForm = {
        id: row.id,
        merchantId: row.merchantId || "",
        providerId: row.providerId || "",
        // 百分比字段转换：小数转百分比
        quotePrice: row.quotePrice
          ? (parseFloat(row.quotePrice) * 100).toFixed(2)
          : "",
        modifiedPrice: row.modifiedPrice
          ? (parseFloat(row.modifiedPrice) * 100).toFixed(2)
          : "",
        actualQuotePrice: row.actualQuotePrice
          ? (parseFloat(row.actualQuotePrice) * 100).toFixed(2)
          : "",
        rebate: row.rebate ? (parseFloat(row.rebate) * 100).toFixed(2) : "",
        // 日期字段：确保是字符串格式
        lastModifiedPriceDate: row.lastModifiedPriceDate || "",
        actualQuoteModifiedPrice: row.actualQuoteModifiedPrice
          ? (parseFloat(row.actualQuoteModifiedPrice) * 100).toFixed(2)
          : "",
        actualQuoteModifiedPriceDate: row.actualQuoteModifiedPriceDate || "",
        businessType: row.businessType || "",
        invoiceContent: row.invoiceContent || "",
        isCreateGroup: row.isCreateGroup !== undefined ? row.isCreateGroup : "",
        signDate: row.signDate || "",
        startDate: row.startDate || "",
        archiveDate: row.archiveDate || "",
        accountStatus: row.accountStatus !== undefined ? row.accountStatus : "",
        specialIndustry: row.specialIndustry !== undefined ? row.specialIndustry : "",
        remark: row.remark || "",
        providerIds: row.providerId ? [row.providerId] : [],
      };

      // 清除表单验证状态
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate();
      }
    },

    reset() {
      this.signOrderDate = [];
      this.providerDisabledDateRange = [];
      this.formInline = {
        status: "",
        page: 1,
        pageSize: 10,
        merchantName: "",
        providerName: "",
        startSignDate: "",
        endSignDate: "",
        phoneSaleName: "",
        faceSaleName: "",
        transferPhoneSalesName: "",
        transferFaceSalesName: "",
        ownerName: "",
        location: "",
        hasRebate: "",
        providerEnableStatus: "",
      };
      this.getdata(this.formInline);
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      let params = {
        page: parameter.page,
        pageSize: parameter.pageSize,
        merchantName: parameter.merchantName,
        providerName: parameter.providerName,
        startSignDate: this.signOrderDate[0] || "",
        endSignDate: this.signOrderDate[1] || "",
        phoneSaleName: parameter.phoneSaleName,
        faceSaleName: parameter.faceSaleName,
        transferPhoneSalesName: parameter.transferPhoneSalesName,
        transferFaceSalesName: parameter.transferFaceSalesName,
        ownerName: parameter.ownerName,
        location: parameter.location || "",
        hasRebate:
          parameter.hasRebate === "" ? undefined : parameter.hasRebate,
        providerEnableStatus:
          parameter.providerEnableStatus === "" ||
          parameter.providerEnableStatus === undefined ||
          parameter.providerEnableStatus === null
            ? undefined
            : parameter.providerEnableStatus,
        startDisabledDate: this.providerDisabledDateRange[0] || "",
        endDisabledDate: this.providerDisabledDateRange[1] || "",
        export: 0,
      };
      getCustomerSignOrders(params)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    exprotData() {
      this.exportButtonLoading = true;
      let params = {
        page: 1,
        pageSize: 999999999,
        merchantName: this.formInline.merchantName,
        providerName: this.formInline.providerName,
        startSignDate: this.signOrderDate[0] || "",
        endSignDate: this.signOrderDate[1] || "",
        phoneSaleName: this.formInline.phoneSaleName,
        faceSaleName: this.formInline.faceSaleName,
        transferPhoneSalesName: this.formInline.transferPhoneSalesName,
        transferFaceSalesName: this.formInline.transferFaceSalesName,
        ownerName: this.formInline.ownerName,
        location: this.formInline.location || "",
        hasRebate:
          this.formInline.hasRebate === "" ? undefined : this.formInline.hasRebate,
        providerEnableStatus:
          this.formInline.providerEnableStatus === "" ||
          this.formInline.providerEnableStatus === undefined ||
          this.formInline.providerEnableStatus === null
            ? undefined
            : this.formInline.providerEnableStatus,
        startDisabledDate: this.providerDisabledDateRange[0] || "",
        endDisabledDate: this.providerDisabledDateRange[1] || "",
        export: 1,
      };
      getCustomerSignOrders(params)
        .then((res) => {
          this.exportButtonLoading = false;
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.exportButtonLoading = false;
        });
    },

    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },

    handlesDelete(row) {
      MessageBox.confirm(`此操作将删除签单表，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteCustomerSignOrders(row)
          .then((res) => {
            if (res.msg == "success") {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getdata(this.formInline);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          })
          .catch((err) => {});
      });
    },

    // 编辑、增加页面保存方法
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const submitData = {
            ...this.editForm,
            providerId:
              this.editForm.providerIds && this.editForm.providerIds.length > 0
                ? this.editForm.providerIds[0]
                : 0,
            quotePrice: this.editForm.quotePrice
              ? Number((Number(this.editForm.quotePrice) / 100).toFixed(4))
              : null,
            modifiedPrice: this.editForm.modifiedPrice
              ? Number((Number(this.editForm.modifiedPrice) / 100).toFixed(4))
              : null,

            actualQuotePrice: this.editForm.actualQuotePrice
              ? Number(
                  (Number(this.editForm.actualQuotePrice) / 100).toFixed(4)
                )
              : null,
            rebate: this.editForm.rebate
              ? Number((Number(this.editForm.rebate) / 100).toFixed(4))
              : null,
            actualQuoteModifiedPrice: this.editForm.actualQuoteModifiedPrice
              ? Number(
                  (
                    Number(this.editForm.actualQuoteModifiedPrice) / 100
                  ).toFixed(4)
                )
              : null,
          };
          if (this.addDialog.type == "add") {
            saveCustomerSignOrders(submitData)
              .then((res) => {
                if (res.msg === "success") {
                  this.$message({
                    type: "success",
                    message: "签单表新增成功!",
                  });
                  this.submitLoading = false;
                  this.closeAddDialog();
                  this.getdata(this.formInline);
                } else {
                  this.$message.error(res.msg);
                  this.submitLoading = false;
                }
              })
              .catch((err) => {
                this.submitLoading = false;
                this.$message.error("新增签单表失败，请稍后再试！");
              });
          } else if (this.addDialog.type == "edit") {
            updateCustomerSignOrders(submitData)
              .then((res) => {
                if (res.msg === "success") {
                  this.$message({
                    type: "success",
                    message: "签单表新增成功!",
                  });
                  this.submitLoading = false;
                  this.closeAddDialog();
                  this.getdata(this.formInline);
                } else {
                  this.$message.error(res.msg);
                  this.submitLoading = false;
                }
              })
              .catch((err) => {
                this.submitLoading = false;
                this.$message.error("新增签单表失败，请稍后再试！");
              });
          }
        }
      });
    },

    onOpenAddDialog() {
      this.addDialog.visible = true;
      this.addDialog.type = "add";
      this.addDialog.title = "新增";

      this.editForm = {
        merchantId: "",
        providerId: "",
        providerIds: [],
        quotePrice: "",
        modifiedPrice: "",
        lastModifiedPriceDate: "",
        actualQuotePrice: "",
        rebate: "",
        actualQuoteModifiedPrice: "",
        actualQuoteModifiedPriceDate: "",
        businessType: "",
        invoiceContent: "",
        isCreateGroup: "",
        signDate: "",
        startDate: "",
        archiveDate: "",
        accountStatus: "",
        specialIndustry: "",
        remark: "",
      };
    },
    closeAddDialog() {
      this.addDialog.visible = false;
    },
    exampleDownload() {
      matchSettlementTemplate()
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    fileOnChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.matchFileList = fileList;
    },
    handleMatchRemove() {},
    matchDialogOpen() {
      this.matchFileList = [];
    },
    onOpenMatchDialog() {
      this.matchDialog.title = "匹配结算数据";
      this.matchDialog.visible = true;
    },

    closeMatchDialog() {
      this.matchDialog.visible = false;
    },
    submitMatchTempForm() {
      if (this.matchFileList.length == 0) {
        this.$message({
          type: "error",
          message: "请先完善信息！",
        });
        return;
      }
      this.matchDialog.loading = true;

      const formData = new FormData();
      formData.append("file", this.matchFileList[0].raw);
      formData.append("matchMonth", this.matchForm.matchMonth);
      matchSettlement(formData)
        .then((res) => {
          this.matchDialog.loading = false;
          if (res.msg == "success") {
            this.closeMatchDialog();
            this.$message({
              type: "success",
              message: "结算数据匹配中，请在匹配记录中查看",
            });
            this.onMatchLog();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.matchDialog.loading = false;
        });
    },
    onMatchLog() {
      this.$router.push({ path: "/oms/matchLog" });
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
  },
};
</script>

<style scoped>
/* 顶部搜索区域 */
.customer-sign-order-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.search-section {
  margin-top: 24px;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.search-form .search-date-picker {
  width: 240px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
}
.toolbar .el-button + .el-button {
  margin-left: 10px;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.pagination-wrap {
  margin-top: 16px;
}

.left-actions .el-button + .el-button {
  margin-left: 8px;
}

.userRole {
  width: 100%;
}
.table-status-icon {
  font-size: 16px;
  cursor: default;
}

.price-cell:hover {
  color: #409eff;
}

/* 价格历史记录弹窗样式 */
.price-history-container {
  max-height: 500px;
  overflow-y: auto;
  padding: 10px;
}

.sign-dialog .el-dialog__body {
  max-height: 520px;
  overflow-y: auto;
  padding: 18px 24px 8px;
}

.sign-dialog .el-dialog__footer {
  padding: 10px 24px 20px;
}

.price-history-dialog .el-dialog__body {
  padding: 12px 20px 8px;
}

.match-dialog .el-form {
  padding-top: 10px;
}

.match-dialog .el-dialog__body {
  padding: 16px 24px 8px;
}

.history-card {
  margin-bottom: 10px;
}

.history-card.el-card.is-always-shadow {
  border-color: inherit;
}

.history-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.price-change {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 500;
  min-height: 32px;
}

.old-price {
  color: #f56c6c;
  text-decoration: line-through;
  margin-right: 8px;
}

.change-icon {
  margin: 0 12px;
  color: #909399;
}

.new-price {
  color: #67c23a;
  font-weight: 600;
  margin-right: 12px;
}

.change-type-tag {
  align-self: center;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  margin-left: 0;
  padding-left: 0;
}

.detail-item .label {
  min-width: 50px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  white-space: nowrap;
}

.detail-item .value {
  flex: 1;
  color: #303133;
  word-break: break-word;
  line-height: 1.5;
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  font-size: 60px;
  color: #dcdfe6;
  margin-bottom: 16px;
}

.empty-text {
  color: #909399;
  font-size: 14px;
  margin: 0;
}
</style>





// WEBPACK FOOTER //
// src/views/oms/customerSignOrder.vue